module.exports = __webpack_public_path__ + "static/img/xj_image.5d01607.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_image.jpg
// module id = C6Wc
// module chunks = 4